"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_dom_1 = __importDefault(require("react-dom"));
var Typography_1 = __importDefault(require("../Typography"));
var styles_1 = require("./styles");
var getTooltipPortalContainer = function () {
    var ROOT_ID = 'root';
    var TOOLTIP_CONTAINER_ID = 'hover-tooltip-container';
    var rootElement = document.getElementById(ROOT_ID);
    if (!rootElement) {
        throw new Error('Root element not found');
    }
    var element = document.getElementById(TOOLTIP_CONTAINER_ID);
    if (element) {
        return element;
    }
    var newElement = document.createElement('div');
    newElement.id = TOOLTIP_CONTAINER_ID;
    rootElement.after(newElement);
    return newElement;
};
var HoverTooltip = function (_a) {
    var children = _a.children, text = _a.text, width = _a.width, _b = _a.placement, placement = _b === void 0 ? 'top' : _b;
    var _c = (0, react_1.useState)(false), isVisible = _c[0], setIsVisible = _c[1];
    var _d = (0, react_1.useState)(placement), actualPlacement = _d[0], setActualPlacement = _d[1];
    var _e = (0, react_1.useState)({ top: 0, left: 0 }), position = _e[0], setPosition = _e[1];
    var containerRef = (0, react_1.useRef)(null);
    var measureTooltipRef = (0, react_1.useRef)(null);
    var handleMouseEnter = function () {
        setIsVisible(true);
    };
    var handleMouseLeave = function () {
        setIsVisible(false);
    };
    (0, react_1.useEffect)(function () {
        if (isVisible && containerRef.current && measureTooltipRef.current) {
            var triggerRect_1 = containerRef.current.getBoundingClientRect();
            var tooltipRect = measureTooltipRef.current.getBoundingClientRect();
            var viewport = {
                width: window.innerWidth,
                height: window.innerHeight,
            };
            var newPlacement = placement;
            // Use actual tooltip dimensions for boundary checking
            var tooltipWidth = tooltipRect.width;
            var tooltipHeight = tooltipRect.height;
            // Calculate base position for original placement
            var top_1 = 0;
            var left = 0;
            var calculatePosition = function (currentPlacement) {
                switch (currentPlacement) {
                    case 'top':
                        return {
                            top: triggerRect_1.top - 6,
                            left: triggerRect_1.left + triggerRect_1.width / 2,
                        };
                    case 'bottom':
                        return {
                            top: triggerRect_1.bottom + 6,
                            left: triggerRect_1.left + triggerRect_1.width / 2,
                        };
                    case 'left':
                        return {
                            top: triggerRect_1.top + triggerRect_1.height / 2,
                            left: triggerRect_1.left - 6,
                        };
                    case 'right':
                        return {
                            top: triggerRect_1.top + triggerRect_1.height / 2,
                            left: triggerRect_1.right + 6,
                        };
                    default:
                        return {
                            top: triggerRect_1.top - 6,
                            left: triggerRect_1.left + triggerRect_1.width / 2,
                        };
                }
            };
            // Calculate initial position
            var initialPos = calculatePosition(placement);
            top_1 = initialPos.top;
            left = initialPos.left;
            // Check boundaries and adjust placement if needed
            if (top_1 - tooltipHeight < 0) {
                newPlacement = 'bottom';
            }
            else if (top_1 + tooltipHeight > viewport.height) {
                newPlacement = 'top';
            }
            else if (left - tooltipWidth < 0) {
                newPlacement = 'right';
            }
            else if (left + tooltipWidth > viewport.width) {
                newPlacement = 'left';
            }
            // Recalculate position for new placement if it changed
            if (newPlacement !== placement) {
                var newPos = calculatePosition(newPlacement);
                top_1 = newPos.top;
                left = newPos.left;
            }
            // Ensure horizontal centering doesn't push tooltip off screen (for top/bottom placements)
            if (newPlacement === 'top' || newPlacement === 'bottom') {
                var halfWidth = tooltipWidth / 2;
                if (left - halfWidth < 0) {
                    left = halfWidth;
                }
                else if (left + halfWidth > viewport.width) {
                    left = viewport.width - halfWidth;
                }
            }
            // Ensure vertical centering doesn't push tooltip off screen (for left/right placements)
            if (newPlacement === 'left' || newPlacement === 'right') {
                var halfHeight = tooltipHeight / 2;
                if (top_1 - halfHeight < 0) {
                    top_1 = halfHeight;
                }
                else if (top_1 + halfHeight > viewport.height) {
                    top_1 = viewport.height - halfHeight;
                }
            }
            setActualPlacement(newPlacement);
            setPosition({ top: top_1, left: left });
        }
    }, [isVisible, placement, width]);
    var portalContainer = getTooltipPortalContainer();
    return ((0, jsx_runtime_1.jsxs)(styles_1.Container, __assign({ ref: containerRef, "data-testid": "tooltipContainer", onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: [children, isVisible &&
                react_dom_1.default.createPortal((0, jsx_runtime_1.jsx)(styles_1.TooltipContainer, __assign({ style: { width: width, top: position.top, left: position.left }, placement: actualPlacement }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default.Body, { children: text }) })), portalContainer), (0, jsx_runtime_1.jsx)(styles_1.MeasuringTooltipContainer, __assign({ ref: measureTooltipRef, style: { width: width, opacity: 0, pointerEvents: 'none' }, placement: placement }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default.Body, { children: text }) }))] })));
};
exports.default = HoverTooltip;
